import { axios } from "@/lib/axios";
import { AxiosResponse } from "axios";

export const apiGetSearchEthniesAndOrigins = (): Promise<
  AxiosResponse<any, any>
> => {
  return axios.get("/profile-s/api/v1/profiles/countries-ethnicities");
};
